
import { EpDevPApiClient } from '../EpDevPApiClient';
import {
  IEpDevPListOrganizationsResponse,
  IEpDevPOrganizationConfigResponse,
  IEpDevPOrgannizationsApiClient,
} from '../types';
import { 
  EpDevPOrganizationsApiPathsFactory 
} from './EpDevPOrganizationsApiFactories';

export class EpDevPOrganizationsApiClient extends EpDevPApiClient implements IEpDevPOrgannizationsApiClient {

  public async listOrganizations(): Promise<IEpDevPListOrganizationsResponse> {
    const epDevPListOrganizationsResponse: IEpDevPListOrganizationsResponse = await this.request({
      method: 'GET',
      url: await this.createUrl(EpDevPOrganizationsApiPathsFactory.createListPath())
    });    
    return epDevPListOrganizationsResponse;
  }

  public async getOrganizationConfig({ organizationId }: {
    organizationId: string;
  }): Promise<IEpDevPOrganizationConfigResponse> {
    const epDevPOrganizationConfigResponse: IEpDevPOrganizationConfigResponse = await this.request({
      method: 'GET',
      url: await this.createUrl(EpDevPOrganizationsApiPathsFactory.createGetConfigPath({ organizationId: organizationId }))
    });
    return epDevPOrganizationConfigResponse;
  }
}
